import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment.prod';

@Injectable({
  providedIn: 'root'
})

export class DocumentService {

  API_URI = environment.API_URL;
  API_SERVER_PHP = environment.API_SERVER_PHP;

  constructor(private http: HttpClient) { }

  guardarImg(pdf: FormData) {
    return this.http.post(`${this.API_SERVER_PHP}/insertarImage.php`, pdf);
  }

  eliminarImagen(nombre: string) {
    return this.http.delete(`${this.API_SERVER_PHP}/eliminarImagen.php?nombre=${nombre}`);
  }

  guardarPdf(pdf: FormData) {
    return this.http.post(`${this.API_SERVER_PHP}/insertarPdf.php`, pdf);
  }

  eliminarPDF(nombre: string) {
    return this.http.delete(`${this.API_SERVER_PHP}/eliminarPDF.php?nombre=${nombre}`);
  }

}